'use strict';

module.exports = function px(number) {
	const parsed = number && parseFloat(number);
	if (parsed && Number.isFinite(parsed)) {
		return `${parsed}px`;
	} else {
		return '0';
	}
};
